import axiosBaseApi from '@/services/common/lib/axiosBaseApi';
import { User } from '@/services/user/userTypes';

export const me = async () => await axiosBaseApi.get<User>(`/v1/auth/me`);
